import React from "react";
import { Switch, Route } from "react-router-dom";
import LandingPages from "../src/View/LandingPages";
import Signin from "./View/Web/Signin";
import ForgetPassword from "./View/Web/ForgetPassword";
import ResetPassword from "./View/Web/ResetPassword";
import Signup from "./View/Web/Signup";
import Blogs from "./View/Web/Blogs";
import Furits from "./View/Web/Furits";
import Intro from "./View/Web/Intro";
import LatestPost from "./View/Web/LatestPost";
import DashboardNavbar from "./View/Panel/Dashboard/DashboardNavbar";
import ViewConsutations from "../src/View/Panel/ViewConsutation/ViewConsutations";
import ConsultaionsForm from "./ConsultaionsForm/Index";
import AddRemove from "./ConsultaionsForm/AddRemove";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import VideoChat from "./View/Panel/VideoChat/VideoChat";
import Review from "./View/Web/Review";
import ProtectedRoute from "./Components/ProtectedRoute";
import Chat from "./View/Panel/Chat/Chat";
import MessageSec from "./Components/Chat/MessageSec";
import MessagingPage from "./View/Panel/Messages/Messages";
import Notification from "./View/Panel/Notifications/Notification";
import LandingPage from "./View/LandingPage";
import LoginOtp from "./View/Web/LoginOtp";
import Page404 from "./View/Web/Page404";

const Login = React.lazy(() => import("./View/Web/Signin"));

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const Routes = () => {
  return (
    <div>
      <React.Suspense fallback={loading}>
        <Switch>
          {/* <Route exact path="/" component={LandingPages} /> */}
          <Route exact path="/" component={LandingPage} />
          <Route path="/sign-in" component={Login} />
          <Route path="/otp-verification" component={LoginOtp} />
          <Route path="/forget-password" component={ForgetPassword} />
          <Route path="/reset-password/:token" component={ResetPassword} />
          <Route path="/sign-up" component={Signup} />
          <Route path="/Blogs" component={Blogs} />
          <Route path="/Furits" component={Furits} />
          <Route path="/addremove" component={AddRemove} />
          <Route path="/Intro" component={Intro} />
          <Route path="/LatestPost" component={LatestPost} />
          <Route path="/dashboard/video-chat" component={VideoChat} />
          {/* <Route path="/dashboard/chat" component={MessagingPage} /> */}
          <ProtectedRoute path="/dashboard" component={DashboardNavbar} />
          <Route path="/review/:id" component={Review} />

          <Route
            path="/dashboard/ViewConsutations/:id"
            component={ViewConsutations}
          />
          <Elements
            stripe={loadStripe(
              "pk_test_51H1mhNBJYyRfYsmarPfQ3mKYVqPrN77g8CuStOvll6SvJ22zOFZE9ojoPZlR9TNgd88lfwIFltkyrKbDWTfJptvi00vVIrXFaX"
            )}
          >
            <Route path="/consultation-form" component={ConsultaionsForm} />
          </Elements>
          <Route path="*" component={Page404} />
        </Switch>
      </React.Suspense>
    </div>
  );
};

export default Routes;
